import { useMemo } from "react"
import Schema from "./Schema"

const WebSiteSchema = () => {
  const schema = useMemo(() => ({
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Majordomo - хостинг провайдер',
    url: `https://${process.env.NEXT_PUBLIC_DOMAIN}`,
    description: 'Хостинг для бизнеса, гос. организаций и частных пользователей. Покупка доменных имён, хостинг сайтов, VDS/VPS хостинг, аренда серверов, SSL сертификаты, лицензии 1С-Битрикс.',
    
    // Поиск на сайте
    potentialAction: {
      '@type': 'SearchAction',
      target: `https://${process.env.NEXT_PUBLIC_DOMAIN}/?search={query}`,
      query: 'required',
    },
    
    // Социальные сети
    sameAs: [
      'https://t.me/majordomo_ru',
      'https://vk.com/majordomo_live',
      'https://zen.yandex.ru/id/61e95d9bcacc3718a6833a53',
      'https://www.youtube.com/channel/UCKUbH9NxgmjMVytBsVjr4xw'
    ],
  }), [])

  return (
    <Schema schema={schema} />
  )
}

export default WebSiteSchema

